import axios from 'axios';
import * as vars from './vars';


export function getLeaderboardEntries(program) {
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/untrusted/referrals/GetLeaderboard',
        headers: {api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken},
        data: {
            program: program
        }
    })
}

export function getLeaderboardRanking(program, jwt) {
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/untrusted/referrals/GetLeaderboardRanking',
        headers: {api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: {
            program: program
        }
    })
}

export function getReferralStatistics(program, jwt) {
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/referrals/GetUserReferralStatistics',
        headers: {api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: {
            program: program
        }
    })
}

export function sendStudentReferral(email, program, jwt) {
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/referrals/CreateReferral',
        headers: {api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: {email: email, program: program}
    })
}


export function logElementInteraction(logElementInteractionRequest) {
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/untrusted/metrics/LogElementInteraction',
        headers: {api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken},
        data: logElementInteractionRequest
    })
}
